import Icon from "@mdi/react";
import { mdiFacebook, mdiInstagram, mdiPhone } from "@mdi/js";
import { LanguageSwitch, Link, useLang } from "./components/Language";

export default function Layout({ children }: { children: React.ReactNode }) {
    const lang = useLang();

    return <>
        <header>
            <div className="content">
                <Link to="/">
                    <div className="logo" />
                </Link>
                <div className="right">
                    <LanguageSwitch />
                    <Link className="button" to="/kontakty">
                        <span className="pc">{lang === "cs" ? "Kontaktujte nás" : "Skontaktuj się z nami"}</span>
                        <span className="mobile"><Icon path={mdiPhone} size={1} /></span>
                    </Link>
                </div>
            </div>
        </header>
        <nav>
            <div className="content">
                <Link className="grow-1" to="/">{lang === "cs" ? "Úvod" : "Wstęp"}</Link>
                <Link className="grow-1" to="/o-nas">{lang === "cs" ? "O nás" : "O nas"}</Link>
                <Link className="grow-2" to="/uredni-deska">{lang === "cs" ? "Úřední deska" : "Tablica urzędowa"}</Link>
                <Link className="grow-2" to="/verejne-dokumenty">{lang === "cs" ? "Veřejné dokumenty" : "Dokumenty publiczne"}</Link>
                <Link className="grow-1" to="/turista">{lang === "cs" ? "Turista" : "Turysta"}</Link>
                <Link className="grow-1" to="/vzdelavani">{lang === "cs" ? "Vzdělávání" : "Edukacja"}</Link>
                <Link className="grow-4" to="/krakonosovy-letni-podvecery">{lang === "cs" ? "Krakonošovy letní podvečery" : "Letnie wieczory z karkonoskim duchem"}</Link>
                <a className="icon grow-0" target="_blank" href="https://www.facebook.com/jilemnicko/">
                    <Icon path={mdiFacebook} size={1.5} />
                </a>
                <a className="icon grow-0" target="_blank" href="https://www.instagram.com/jilemnicko/">
                    <Icon path={mdiInstagram} size={1.5} />
                </a>
            </div>
        </nav>

        {children}
    </>;
}
